import React from 'react';
import {
  FooterDiv,
  Background,
  Derechos,
  Aviso
} from '../styles/template/footer.styles';

const Footer = () => {
    const date = new Date();
    const currentYear = date.getFullYear();
    
    return (  
        <FooterDiv>
            <Background>
                <Derechos>
                    Todos los derechos reservados &copy; {currentYear} | &nbsp;
                    <Aviso to="/aviso">
                        Aviso de Privacidad
                    </Aviso>
                </Derechos>
            </Background>
        </FooterDiv>
    );
}
 
export default Footer;